var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background w-100 h-100 bg-size-cover bg-position-center",style:(_vm.bgStyles)})}
var staticRenderFns = []

export { render, staticRenderFns }